<template>
  <div
    class="w-full h-auto float-left rounded-lg bg-white px-5 py-4 shadow"
    style="transition: 1s"
  >
    <div class="spring-spinner" :class="{ hidden: !loading }">
      <div class="spring-spinner-part top">
        <div class="spring-spinner-rotator"></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div class="spring-spinner-rotator"></div>
      </div>
    </div>
    <div
      class="w-full float-left flex flex-col gap-5 font-medium"
      :class="{ hidden: loading }"
      style="transition: 1s"
    >
      <div class="w-full float-left">
        <div class="w-full float-left">
          <p class="float-left text-black text-sm">Order #{{ data.id }}</p>
          <p class="float-right text-gray text-sm">
            {{ $t(`order-statuses.${data.status}`) }}
          </p>
        </div>
      </div>

      <div v-if="data.ride && data.ride.captain" class="w-full float-left">
        <div class="w-full float-left flex flex-row items-center gap-2">
          <img
            src="../assets/profile/driver-avatar.svg"
            alt="driver"
            width="24"
            height="24"
            class="rounded-full overflow-hidden img-shadow"
          />
          <label class="text-sm"
            >{{ $t("general.driver") }}:
            {{ data.captain_name || data.ride.captain.full_name }} #{{
              data.captain_username || data.ride.captain.username
            }}
          </label>
        </div>
        <div>
          <p class="text-sm" v-if="data.ride.car.brand_model">
            <span class="font-light"
              >{{ $t(`place-order.car`) }}:
              {{
                data["car_brand" + primaryLang] ||
                data.ride.car.brand_model.brand["name" + primaryLang]
              }}
              ,
              {{
                data["car_brand_model" + primaryLang] ||
                data.ride.car.brand_model["name" + primaryLang]
              }},
              {{
                data["car_color" + primaryLang] ||
                data.ride.car.color["name" + primaryLang]
              }}</span
            >
          </p>
          <p class="text-sm" v-if="data.ride.car.plate_number">
            <span class="font-light"
              >{{ $t(`place-order.plate-number`) }}:
              {{ data.car_plate_number || data.ride.car.plate_number }}</span
            >
          </p>
        </div>

        <!-- QA #2: driver phone (for calling) + text chat with the captain -->
        <div
          class="w-full float-left flex flex-row items-center gap-3 mt-2 flex-wrap"
          v-if="driverPhone"
        >
          <a
            :href="'tel:' + driverPhone"
            class="text-sm flex items-center gap-1"
            style="color: #241f20"
          >
            <i class="pi pi-phone"></i>
            {{ $t("general.phone_number") }}:
            <span dir="ltr">{{ driverPhone }}</span>
          </a>
          <button
            class="text-sm flex items-center gap-1"
            style="
              color: #54b367;
              border: 1px solid #54b367;
              border-radius: 16px;
              padding: 3px 12px;
              background: #fff;
              cursor: pointer;
            "
            @click="chatDialog = true"
          >
            <i class="pi pi-comments"></i> {{ $t("chat.chat_with_driver") }}
          </button>
        </div>
      </div>
      <div class="w-full float-left">
        <div class="w-full flex flex-row items-center">
          <div
            class="rounded-full float-left"
            style="
              width: 15px;
              height: 15px;
              min-width: 15px;
              min-height: 15px;
              background-color: white;
              box-shadow: inset 0 0 0 2px #e10015;
            "
          ></div>
          <label class="float-left ml-2 text-sm text-black">{{
            data.pick_up_area["name" + primaryLang] ||
            data.pick_up_area["name" + secondaryLang]
          }}</label>
        </div>
        <div
          class="w-full flex flex-row items-center mt-4"
          v-if="data.pull_down_area"
        >
          <div
            class="rounded-full float-left"
            style="
              width: 15px;
              height: 15px;
              min-width: 15px;
              min-height: 15px;
              background-color: #e10015;
            "
          ></div>
          <label class="float-left ml-2 text-sm text-black">{{
            data.pull_down_area["name" + primaryLang] ||
            data.pull_down_area["name" + secondaryLang]
          }}</label>
        </div>
      </div>
      <p class="datetime">
        <span class="material-icons middle">miscellaneous_services</span>
        <span class="middle">{{
          data.service["name" + primaryLang] ||
          data.pull_down_area["name" + secondaryLang]
        }}</span>
      </p>
      <!-- A div, not a p: a p cannot contain the two p rows below
           (invalid HTML that prettier refuses to parse). -->
      <div class="w-full float-left text-sm text-gray">
        <p class="datetime">
          <span class="material-icons middle">schedule</span>
          <span class="middle">{{ formateDateTime(data.created_at) }}</span>
        </p>

        <p class="datetime" v-if="!data.now">
          <span class="material-icons middle">departure_board</span>
          <span class="middle">{{ formateDateTime(data.datetime) }}</span>
        </p>
      </div>
      <div v-if="actions" class="w-full float-left">
        <div class="divider"></div>
        <div class="w-full float-left mt-4 flex flex-row gap-2">
          <button v-for="(action, index) in actions" :key="index">
            <img
              :src="require(`../assets/${action.img}`)"
              @click="handleFunctionCall(action.method)"
            />
          </button>
        </div>
      </div>

      <div v-if="data.status === 'DONE'" class="w-full float-left">
        <div class="divider"></div>
        <button class="pay-now-btn mt-4" @click="paymentDialog = true">
          {{ $t("payment.pay_now") }}
        </button>
      </div>
    </div>

    <PaymentDialog
      v-model:visible="paymentDialog"
      :bookingId="data.id"
      :amount="payableAmount"
      @paid="onPaid"
    />

    <ChatDialog
      v-model:visible="chatDialog"
      :bookingId="data.id"
      :captainName="
        data.ride && data.ride.captain ? data.ride.captain.full_name : ''
      "
    />

    <Dialog
      :header="$t('general.cancellation_reason')"
      v-model:visible="cancellationDialog"
      style="width: 500px; border-radius: 5px"
    >
      <div
        v-for="option in cancellationReasons"
        :key="option.id"
        class="radio-option"
      >
        <input
          type="radio"
          :value="option.id"
          v-model="returnCancellationReason"
          :id="option.id"
          class="radio-input"
        />
        <label :for="option.id" class="radio-label">{{
          option["text" + primaryLang]
        }}</label>
      </div>
      <br />
      <button class="cancel-btn" :loading="loading" @click="submitCancelOrder">
        {{ $t("general.submit") }}
      </button>
    </Dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  formatCompanyTime,
  toCompanyMoment,
  companyNow,
} from "@/utils/companyTime";
import Dialog from "primevue/dialog";
import PaymentDialog from "@/components/PaymentDialog.vue";
import ChatDialog from "@/components/ChatDialog.vue";

export default {
  name: "ReservationOrders",
  props: {
    initData: {
      type: Object,
      required: false,
    },
    id: {
      required: false,
    },
  },
  components: {
    Dialog,
    PaymentDialog,
    ChatDialog,
  },
  data() {
    return {
      cancellationReasons: [],
      cancellationDialog: false,
      returnCancellationReason: "",
      paymentDialog: false,
      chatDialog: false,
      constraints: [],
      data: {},
      actions: [
        // { img: "actions/cancel.svg", action: "cancel", method: "cancelOrder" },
      ],
      pickup: "",
      destination: "",
      dispatched: true,
      loading: false,
      showPastTime: false,
      timer: "",
    };
  },
  computed: {
    primaryLang() {
      if (this.$store.getters.selectedLanguage == "en") return "_en";
      else return "_ar";
    },
    payableAmount() {
      return (
        (this.data && this.data.meter && this.data.meter.to_pay) ||
        this.data.to_pay ||
        null
      );
    },
    secondaryLang() {
      if (this.$store.getters.selectedLanguage == "en") return "_ar";
      else return "_en";
    },
    // QA #2: the captain's phone. From the GET-booking shape it is
    // ride.captain.username (= phone); the socket status event delivers it flat
    // as captain_phone_number. taxi_number is the username alias.
    driverPhone() {
      const cap = this.data && this.data.ride && this.data.ride.captain;
      return (
        (cap && (cap.phone_number || cap.username)) ||
        this.data.captain_phone_number ||
        this.data.taxi_number ||
        null
      );
    },
  },
  created() {
    if (this.initData) {
      this.data = this.initData;

      this.updateTimer();
      setInterval(() => {
        this.updateTimer();
      }, 1000);

      if (this.data.dynamic_constraints) {
        console.log("this.data.dynamicConstraints");
        console.log(this.data.dynamic_constraints);
        this.data.dynamic_constraints.forEach((item) => {
          this.constraints.push({
            title: item.Abbreviation,
            img: this.staticImageConstraint(item.Abbreviation),
            strike_through: item.strike_through || null,
          });
        });
      }
      if (this.data.seats) {
        this.constraints.push({
          title: `${this.data.seats} Passenger${
            this.data.seats > 1 ? "s" : ""
          }`,
          img: "constraints/person.svg",
        });
      }

      if (
        ["PENDING", "ACCEPTED", "STARTED", "ARRIVED"].includes(this.data.status)
      ) {
        this.actions.push({
          img: "actions/cancel.svg",
          action: "cancel",
          method: "cancelOrder",
        });
      }
    }
  },
  methods: {
    staticImageConstraint(constraint_name) {
      var imgPath = null;
      switch (constraint_name) {
        case "pets":
          imgPath = "constraints/animal.svg";
          break;
        case "test":
          imgPath = "constraints/test.svg";
          break;
        case "mad":
          imgPath = "constraints/mad.svg";
          break;
        case "amex":
          imgPath = "constraints/amex.svg";
          break;
        case "low_car":
          imgPath = "constraints/low_car.svg";
          break;
        case "wheelchair":
          imgPath = "constraints/wheelchair.svg";
          break;
        default:
          imgPath = null;
      }
      return imgPath;
    },
    openMap() {
      this.$router.push({
        name: "Details",
        params: {
          data: JSON.stringify(this.data),
          id: this.data.id,
        },
      });
    },
    updateTimer() {
      // Instant compare: data.datetime is Damascus wall time, not PC time.
      const at = toCompanyMoment(this.data.datetime);
      this.timer = at ? at.diff(companyNow(), "minutes") : "";
    },
    cancelOrder() {
      this.$store
        .dispatch("getCancellationReasons")
        .then((data) => {
          this.cancellationReasons = data;
          this.cancellationDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submitCancelOrder() {
      if (!this.returnCancellationReason) {
        this.$notify({
          title: "Error",
          text: "Please choose a reason",
          type: "error",
        });
        return;
      }
      this.loading = true;
      this.axios
        .delete(`${this.$store.state.rootAPI}booking/${this.data.id}`, {
          params: {
            cancellation_reason_id: this.returnCancellationReason,
          },
        })
        .then(() => {
          this.$notify({
            title: "Deleted Successfully",
            text: `Order #${this.cancelledId} has been cancelled`,
            type: "Success",
          });
          this.cancelledId = null;
          this.cancellationDialog = false;
          this.getData();
        })
        .catch((err) => {
          this.$notify({
            title: "Error",
            text: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onPaid() {
      this.data.status = "PAID";
      this.$notify({
        title: this.$t("general.success"),
        text: this.$t("payment.paid_success"),
        type: "success",
      });
    },
    handleFunctionCall(func) {
      this[func]();
    },
    // Final-version doc 2026-10-05: Damascus time, whatever the PC zone.
    formateDateTime(time) {
      return formatCompanyTime(time, "YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.strike_through {
  text-decoration-line: line-through;
}

.pay-now-btn {
  width: 100%;
  max-width: none;
  border: 1px solid #e10015;
  border-radius: 6px;
  background: #e10015;
  color: #fff;
  font-size: 15px;
  padding: 10px 0;
  height: auto;
}

button {
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;

  img {
    width: 100%;
    height: 100%;
  }
}

.constraint-icon {
  max-height: 16px;
  width: auto;
}

.img-shadow {
  box-shadow: 0 0 6px rgba(56, 69, 222, 0.12);
}

.radio-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.radio-option {
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-family: "Poppins";
}

.radio-input {
  width: 10%;
  cursor: pointer;
  accent-color: #4caf50;
  /* Change color of the radio button in modern browsers */
}

.radio-label {
  font-size: 16px;
  cursor: pointer;
}

.cancel-btn {
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
  background: red;
  color: white;
  font-size: large;
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;
}

.datetime {
  width: 100%;
  float: left;
  font-size: 14px;
  color: #788e98;
  font-weight: 400;
}

.middle {
  vertical-align: middle;
  margin: 2px;
}
</style>
